import CrudRepository from './CrudRepository'
export default class OfferSliderRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/websiteSlider/offer')
  }
}
